import { resolveTreatmentPlanSaveStatus } from "./treatmentPlanDisplayUtils";

interface SaveTreatmentPlanUpdateOptions {
  hasAppointmentUpdates?: boolean;
  explicitStatus?: number;
}

export async function saveTreatmentPlanUpdate(
  currentStatus: number,
  save: (status: number, hasAppointmentUpdates?: boolean) => Promise<void>,
  options: SaveTreatmentPlanUpdateOptions = {},
): Promise<void> {
  const { hasAppointmentUpdates, explicitStatus } = options;
  const status = resolveTreatmentPlanSaveStatus(currentStatus, { explicitStatus });
  await save(status, hasAppointmentUpdates);
}
